import React from 'react'

import styles from './Floating.module.scss'

interface DisclaimerProps {
  color?: string
  children: React.ReactNode
  useOldFonts?: boolean
}

export const Disclaimer = (props: DisclaimerProps) => {
  const disclaimerStyles = [styles.disclaimer, 'max-w-sm']
  if (props.color !== 'white') {
    disclaimerStyles.push(styles.darkGrey)
  }
  return (
    <div className={disclaimerStyles.join(' ')}>
      <div
        className={
          props.useOldFonts ? 'old-caption2-regular-400' : 'new-text-s-regular'
        }
      >
        {props.children}
      </div>
    </div>
  )
}
